import { Link, useLocation } from "react-router-dom";
import { Coffee, User, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const SiteHeader = () => {
  const { pathname } = useLocation();
  const { user, logout } = useAuth();
  const signedIn = !!user && user.role === "customer";

  const linkCls = (active) =>
    `transition-colors hover:text-[#C05A46] ${active ? "text-[#C05A46]" : "text-[#4A4341]"}`;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-30 border-b border-black/10 bg-[#F5F5F0]/85 backdrop-blur"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-brand-link"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#C05A46] text-[#F5F5F0]">
            <Coffee className="h-4 w-4" strokeWidth={1.75} />
          </span>
          <span className="font-serif-display text-xl tracking-tight leading-none">
            The Cozy Bean
          </span>
        </Link>

        <nav className="flex items-center gap-4 md:gap-6 text-sm">
          <Link to="/" data-testid="nav-home-link" className={linkCls(pathname === "/")}>Home</Link>
          <Link to="/order" data-testid="nav-order-link" className={linkCls(pathname.startsWith("/order"))}>Order</Link>
          <Link to="/track" data-testid="nav-track-link" className={linkCls(pathname.startsWith("/track"))}>Track</Link>

          {signedIn ? (
            <>
              <Link
                to="/account"
                data-testid="nav-account-link"
                className={`inline-flex items-center gap-1.5 ${linkCls(pathname.startsWith("/account"))}`}
              >
                <User className="h-3.5 w-3.5" /> {user.name?.split(" ")[0] || "Account"}
              </Link>
              <button
                type="button"
                onClick={logout}
                data-testid="nav-signout-btn"
                className="inline-flex items-center gap-1.5 text-[#7B7573] hover:text-[#C05A46] transition-colors"
              >
                <LogOut className="h-3.5 w-3.5" /> Sign out
              </button>
            </>
          ) : (
            <Link
              to="/signin"
              data-testid="nav-signin-link"
              className={`inline-flex items-center gap-1.5 rounded-full border border-[#C05A46]/40 px-3 py-1.5 text-[#C05A46] hover:bg-[#C05A46] hover:text-white transition-colors ${pathname.startsWith("/signin") || pathname.startsWith("/register") ? "bg-[#C05A46] text-white" : ""}`}
            >
              <User className="h-3.5 w-3.5" /> Sign in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
